<template>
  <div>
    <TopNav />
    <div class="main-content">
      <div class="header">
        <div class="container-fluid">
          <div class="header-body">
            <div class="row align-items-end">
              <Head v-if="examDetail !== null" v-bind:route="'HomeWorkDetail'" v-bind:exam_status="startButtonStatus" />
            </div>
            <router-link class="btn btn-light" :to="{ name: 'HomeWorkDetail', params: { id: examID } }"><i class="fe fe-arrow-left"></i> Sınav Detay Ekranına Dön</router-link>
          </div>
          <div v-if="message" class="col-12 alert alert-primary text-center">{{ message }}</div>
          <div v-if="!activeExam()" class="container-fluid p-0 pt-1">
            <ScoreBoard v-if="activeExam() === null" v-bind:score="quizResult" />
            <div class="text-center" v-if="ready">
              <h2 class="text-center">{{ examDetail.SINAV_ADI }}</h2>
              <div class="card-body question-card-body row">
                <div class="col-6 col-lg-6 question-col" :question="q.sinav_soru_id" :key="index" v-for="(q, index) in questions">
                  <div class="card card-fill question-card m-1">
                    <a :ref="'img' + index" :id="'img' + index" class="canvas_area">
                      <small>
                        Soru No: {{ (index+1) }} - {{ q.ders_adi + ' - ' + q.konu + '/' + q.alt_konu }}
                      </small>
                      <img class="card-img-top question_img img-fluid" :title="q.soru_resim ? '' : 'Soru görseli bulunamadı!'" :src="q.soru_resim ? q.soru_resim : '/assets/img/illustrations/lost.svg'" :alt="q.sinav_soru_id + '. Soru Resmi'" />
                    </a>
                    <div class="card-body mt-0" v-if="activeExam() === null">
                      <div class="row align-items-center">
                        <div class="col-12"> <!-- d-flex align-items-end -->
                          <div class="btn-group-toggle btn-group special disabled">
                            <label class="btn" :key="i" v-for="(answer_name, i) in ['A', 'B', 'C', 'D']"
                              :class="answerClass(answer_name, index)" 
                              :for="'i_' + q.sinav_soru_id + '_' + answer_name">
                              <input 
                                :id="'i_' + q.sinav_soru_id + '_' + answer_name"
                                v-model="answers[index]"
                                :name="'i_' + q.sinav_soru_id"
                                :value="answer_name"
                                type="radio">
                                <i :class="answers[index] == answer_name ? 'fe-stop-circle' : 'fe-circle'" class="fe"></i> {{ answer_name }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopNav from '@/components/TopNav'
import ScoreBoard from '@/components/ScoreBoard'
import Head from '@/components/Head'
import base from '@/mixins/base'

export default {
  name: 'HomeWorkDetail',
  components: { TopNav, Head, ScoreBoard },
  mixins: [ base ],
  data () {
    return {
      studentID: this.$store.state.auth.student_id, // Student ID
      examID: this.$route.params.id, // Exam ID
      examDetail: null,  // Exam Datas
      answers: {}, // Student answer
      answersKeys: {}, // Answer Keys
      message: 'Yükleniyor...', // Alert message
      questions: {}, // Question Datas
      startButtonStatus: false, // It's Wokring for Head Component
      quizResult: { // Quiz Computed Result
        true: 0,
        false: 0,
        empty: 0,
        score: 0
      },
      ready: false, // Data Status Variable
    }
  },
  methods: {
    /* Active Tab and Answer Control */
    answerClass(answer_name, index) {
      let ret = ''
      let user_answer = this.answers[index];
      let true_answer = this.answersKeys[index];
      if (!this.activeExam()) { // finished
        if ((user_answer == answer_name && user_answer == true_answer || user_answer != answer_name && user_answer != null) && answer_name == true_answer) {
          ret = 'btn-success'
        } else if (user_answer == answer_name && user_answer != null && user_answer != true_answer) {
          ret = 'btn-danger'
        }
      } else { // progressing
        if (user_answer != null && user_answer == answer_name) {
          ret = 'btn-primary' // checked answer
        }
      }

      if (ret == '') {
        ret = 'btn-white'
      }
      return ret
    },
    activeExam () {
      return this.startButtonStatus == 'Print' ? false : true
    },
    answerControl(answer, index) {
      let ret = false 
      if (localStorage.getItem('HomeWorkQuestionAnswers' + this.examID) !== null) {
        let data = localStorage.getItem('HomeWorkQuestionAnswers' + this.examID)
        if (data[index] !== undefined) {
          if (data[index] == answer) {
            ret = true
          }
        }
      }
      return ret
    },
    
    /* Data Sync and Init Base Libs */
    dataSyncheiser(qs) {
      let local = null
      if (localStorage.getItem('HomeWorkQuestionAnswers' + this.examID) !== null) {
        local = JSON.parse(localStorage.getItem('HomeWorkQuestionAnswers' + this.examID))
      }
      this.questions = qs
      let Atrament = this.$atrament; // eslint-disable-line

      this.questions.forEach((element, index) => {
        this.answersKeys[index] = this.answerHash(element.soru_cevap);
        if (local != null && local[index] != undefined && local[index] != '')
        {
          this.answers[index] = local[index]
        }
        if (element.ogrenci_cevap != '')
        {
          this.answers[index] = element.ogrenci_cevap
        }
      });
      localStorage.setItem('HomeWorkQuestionAnswers' + this.examID, JSON.stringify(this.answers))
    },
    /* External Methods */
    answerHash(answer) {
      let ret = null;
      if(answer == 'db7bc106d8da317dc09f7c624f611ab8') {
        ret = 'A'
      } else if(answer == '26dc21c9db50c4a738994adebdb1228e') {
        ret = 'B'
      } else if(answer == '82c87f2401bd3b08cc5aa7637ed9dedd') {
        ret = 'C'
      } else if(answer == 'bd754e16151a5dec6fc2849150dc83f5') {
        ret = 'D'
      }
      return ret
    }, 
    scoreCalc() {
      let i = 0
      this.quizResult.empty = 0
      this.quizResult.true = 0
      this.quizResult.false = 0
      this.questions.forEach(q => { // eslint-disable-line
        if (this.answers[i] == null) this.quizResult.empty = this.quizResult.empty + 1
        else if (this.answers[i] == this.answersKeys[i]) this.quizResult.true = this.quizResult.true + 1
        else this.quizResult.false = this.quizResult.false + 1
        i = i + 1
      });

      let balance = 100 / (parseInt(this.quizResult.true) + parseInt(this.quizResult.false) + parseInt(this.quizResult.empty));

      if (this.quizResult.true) {
        this.quizResult.score = Math.round(this.quizResult.true * balance);
      }
    }
  },
  created() {
    this.deviceTimeNConnectionCheck()
    let z = setInterval( () => {
      this.answers = localStorage.getItem('HomeWorkQuestionAnswers' + this.examID) !== null ? JSON.parse(localStorage.getItem('HomeWorkQuestionAnswers' + this.examID)) : {}
      if (this.examDetail != null) {
        this.scoreCalc();
        this.totalExamTime = this.examDetail.toplam_sure
        let start_time = localStorage.getItem('HomeWorkQuestionStartTime' + this.examID)
        if (start_time !== null && this.ready && this.examDetail != null) {
          this.ready = true
          this.startButton = true
          let time = this.timeCheck(this.examDetail.baslama_tarihi, this.examDetail.bitis_tarihi, this.examDetail.toplam_sure, start_time) // eslint-disable-line
          
          time = this.secondToTime(time)
          if (time.m <= 0 && Number(time.s) <= 0) {
            this.startButtonText = ''
            this.startButtonStatus = 'Print'
            setTimeout(() => {
              window.print()
            }, 1000);
            clearInterval(z)
          } else {
            this.$route.push({ name: 'HomeWorkDetail', params: { id: this.examID } })
          }
        }
      } else {
        this.message = 'Böyle bir sınav yok!'
      }
    }, 1000);

    if (this.$store.state.exam.home_work === null) {
      this.homeWorkData(this.studentID);
      let x = setInterval( () => {
        if (this.$store.state.exam.home_work !== null) {
          this.questions = this.$store.state.exam.home_work
          this.$store.state.exam.home_work.forEach(question => {
            if (question.SINAV_ID == this.$route.params.id) {
              this.ready = true
              this.message = ''
              this.startButtonStatus = 'Print'
              this.examDetail = question
              this.dataSyncheiser(question.sorular)
              clearInterval(x)
            }
          });
        }
      }, 1);
    } else {
      this.questions = this.$store.state.exam.home_work
      this.$store.state.exam.home_work.forEach(question => {
        if (question.SINAV_ID == this.$route.params.id) {
          this.message = ''
          this.ready = true
          this.startButtonStatus = 'Print'
          this.examDetail = question
          this.dataSyncheiser(question.sorular)
        }
      });
    }
  }
}
</script>
<style scoped>
small {
  font-size: 10px;
}

.jumbotron {
  padding: .1875rem!important;
}

.question-card-body {
  padding: 0;
}
.question-card {
    margin: 0;
}

.question-col {
    padding: 4px;
}

@media print {
  .header-body {
    display: none
  }
  .container {
    display: inline;
  }
  body {
    overflow-y:visible;
  }
}
.disabled {
  pointer-events: none;
}
.blurred {
  filter: blur(9px) grayscale(1);
  pointer-events: none;
}
.btn-group-toggle.special {
  display: flex;
}

.question_img {
  padding: 1em 2em;
  /* width: auto;*/
  max-width: 600px;
  display: block;
  margin: 0 auto;
}
.special .btn {
  flex: 1
}
li.clicked a {
    color: #505050;
    background-color: #e8e8e8;
}
.btn-lg {
  font-size: 25px;
}

@media (max-width: 1199px) {
  .question_img {
    min-width: 35vh
  }
}

.list-group .list-group-item:last-child {
  border: 0;
}

li.false-answer a {
  background: #e63757 !important;
  color: #ffffff !important;
}

li.true-answer a {
  background: #00d97e !important;
  color: #ffffff !important;
}
li.true-answer a.active,
li.false-answer a.active {
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.38);
}
</style>